<template>
  <div
      :class="panel ? 'cp-saturation' : 'saturation'"
      @mousedown.prevent.stop="selectSaturation"
  >
    <canvas ref="canvasSaturation" />
    <div
        :style="slideSaturationStyle"
        :class="panel ? 'cp-saturation__thumb' : 'slide'"
    />
  </div>
</template>

<script>
import mixin from './mixin';

const PANEL_WIDTH  = 256;
const PANEL_HEIGHT = 128;

export default {
  mixins: [mixin],
  props:  {
    color: {
      type:    String,
      default: '#000000',
    },
    hsv: {
      type:    Object,
      default: null,
    },
    size: {
      type:    Number,
      default: 200,
    },
    panel: {
      type:    Boolean,
      default: false,
    },
  },
  data() {
    return { slideSaturationStyle: {} };
  },
  mounted() {
    this.renderColor();
    this.renderSlide();
  },
  methods: {
    renderColor() {
      if (this.panel) {
        this.renderPanelColor();
        return;
      }
      const canvas  = this.$refs.canvasSaturation;
      const size    = this.size;
      const ctx     = canvas.getContext('2d');
      canvas.width  = 200;
      canvas.height = 200;

      ctx.fillStyle = this.color;
      ctx.fillRect(0, 0, size, size);

      this.createLinearGradient('l', ctx, size, size, '#FFFFFF', 'rgba(255,255,255,0)');
      this.createLinearGradient('p', ctx, size, size, 'rgba(0,0,0,0)', '#000000');
    },
    renderPanelColor() {
      const canvas  = this.$refs.canvasSaturation;
      const ctx     = canvas.getContext('2d');
      canvas.width  = PANEL_WIDTH;
      canvas.height = PANEL_HEIGHT;

      ctx.fillStyle = this.color;
      ctx.fillRect(0, 0, PANEL_WIDTH, PANEL_HEIGHT);

      this.createLinearGradient('l', ctx, PANEL_WIDTH, PANEL_HEIGHT, '#FFFFFF', 'rgba(255,255,255,0)');
      this.createLinearGradient('p', ctx, PANEL_WIDTH, PANEL_HEIGHT, 'rgba(0,0,0,0)', '#000000');
    },
    renderSlide() {
      if (this.panel) {
        this.slideSaturationStyle = {
          left:       `${this.hsv.s * 100}%`,
          top:        `${(1 - this.hsv.v) * 100}%`,
          background: this.color,
        };
        return;
      }
      this.slideSaturationStyle = {
        left: `${this.hsv.s * this.size - 5}px`,
        top:  `${(1 - this.hsv.v) * this.size - 5}px`,
      };
    },
    selectSaturation(e) {
      if (this.panel) {
        this.selectPanelSaturation(e);
        return;
      }
      const { top: saturationTop, left: saturationLeft } = this.$el.getBoundingClientRect();
      const ctx                                          = e.target.getContext('2d');

      const mousemove = (e) => {
        let x = e.clientX - saturationLeft;
        let y = e.clientY - saturationTop;

        if (x < 0) {
          x = 0;
        }
        if (y < 0) {
          y = 0;
        }
        if (x > this.size) {
          x = this.size;
        }
        if (y > this.size) {
          y = this.size;
        }
        this.slideSaturationStyle = {
          left: `${x - 5}px`,
          top:  `${y - 5}px`,
        };

        const imgData   = ctx.getImageData(Math.min(x, this.size - 1), Math.min(y, this.size - 1), 1, 1);
        const [r, g, b] = imgData.data;
        this.$emit('selectSaturation', { r, g, b });
      };

      mousemove(e);

      const mouseup = () => {
        document.removeEventListener('mousemove', mousemove);
        document.removeEventListener('mouseup', mouseup);
      };

      document.addEventListener('mousemove', mousemove);
      document.addEventListener('mouseup', mouseup);
    },
    selectPanelSaturation(e) {
      const rect = this.$el.getBoundingClientRect();
      const ctx  = this.$refs.canvasSaturation.getContext('2d');

      const mousemove = (event) => {
        const fx = Math.min(1, Math.max(0, (event.clientX - rect.left) / rect.width));
        const fy = Math.min(1, Math.max(0, (event.clientY - rect.top) / rect.height));

        const x         = Math.min(Math.floor(fx * PANEL_WIDTH), PANEL_WIDTH - 1);
        const y         = Math.min(Math.floor(fy * PANEL_HEIGHT), PANEL_HEIGHT - 1);
        const [r, g, b] = ctx.getImageData(x, y, 1, 1).data;

        this.slideSaturationStyle = {
          left:       `${fx * 100}%`,
          top:        `${fy * 100}%`,
          background: `rgb(${r}, ${g}, ${b})`,
        };
        this.$emit('selectSaturation', { r, g, b });
      };

      mousemove(e);

      const mouseup = () => {
        document.removeEventListener('mousemove', mousemove);
        document.removeEventListener('mouseup', mouseup);
      };

      document.addEventListener('mousemove', mousemove);
      document.addEventListener('mouseup', mouseup);
    },
  },
};
</script>
